
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ceaPatientRegisterApi } from '../api/ceaPatientRegister.api';
import { switchMap, map } from 'rxjs/operators';
import { ceaPatientRegisterData, ceaPatientRegister } from '../../../interfaces/report/ceaPatientRegister';

@Injectable()
export class ceaPatientRegisterService extends ceaPatientRegisterData {

  constructor(private api: ceaPatientRegisterApi) {
    super();
  }


 
  search(url: string,data:any): Observable<any> {
     
    return this.api.search(url,data);
  }

}
